/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'slider',
};
